import { desyncNetwork, syncNetwork } from "@Api/CountrySettings/countryGroup";
import Button from "@Components/Button";
import Card from "@Components/Card";
import RadioGroup from "@Components/Form/RadioGroup";
import Close from "@Components/Icons/Close";
import Loading from "@Components/Icons/Loading";
import InfoPopup from "@Components/InfoPopup";
import { ERROR, SUCCESS } from "@Components/Toast";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { CountryGroupType } from "@Shared/Entities/CountryGroups/CountryGroup/enums";
import React from "react";
import styles from "./index.module.scss";
var Config;
(function (Config) {
    Config["RoamingToIdd"] = "RoamingToIdd";
    Config["IDDToRoaming"] = "IDDToRoaming";
})(Config || (Config = {}));
export default class ToggleSync extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            syncConfig: Config.RoamingToIdd,
        };
    }
    onDesync = async () => {
        if (!this.props.networkId ||
            this.props.countryGroupType === undefined) {
            return;
        }
        this.setState({ isLoading: true });
        try {
            await desyncNetwork(this.props.networkId, this.props.countryGroupType);
            this.props.close(true, false);
            this.props.notify({
                status: SUCCESS,
                title: "Success",
                description: "Roaming and IDD synchronisation is turned off.",
            });
        }
        catch (error) {
            this.props.notify({
                status: ERROR,
                title: "Error",
                description: "Failed to desynchronise settings.",
            });
            console.error("Failed to desynchronise settings", error);
        }
        finally {
            this.setState({ isLoading: false });
        }
    };
    onSync = async () => {
        if (!this.props.networkId || this.state.isLoading) {
            return;
        }
        this.setState({ isLoading: true });
        try {
            const type = this.state.syncConfig === Config.RoamingToIdd
                ? CountryGroupType.Roaming
                : CountryGroupType.IDD;
            await syncNetwork(this.props.networkId, type);
            this.props.close(true, true);
            this.props.notify({
                status: SUCCESS,
                title: "Success",
                description: "Roaming and IDD synchronisation is turned on.",
            });
        }
        catch (error) {
            this.props.notify({
                status: ERROR,
                title: "Error",
                description: "Failed to synchronise settings.",
            });
            console.error("Failed to synchronise settings", error);
        }
        finally {
            this.setState({ isLoading: false });
        }
    };
    toggleOff = (close) => {
        return (React.createElement(Card, { className: styles.toggleSyncPopup },
            React.createElement(Box, { className: styles.header },
                React.createElement("h2", { className: styles.title }, "Synchronise Settings"),
                React.createElement("div", { onClick: () => close(), className: styles.closeBtn },
                    React.createElement(Close, { onClick: () => close(), color: "#585C61", size: "0.75rem", className: styles.exitButton }))),
            React.createElement(Box, { className: styles.content },
                React.createElement("p", null,
                    React.createElement("span", null, "Turning off synchronisation"),
                    " will make Roaming and IDD settings independent. Future changes will no longer be mirrored.")),
            React.createElement(Box, { className: styles.actions },
                React.createElement(Button, { click: () => close(), dark: true, className: styles.cancelBtn }, "CANCEL"),
                React.createElement(Button, { click: this.onDesync, disabled: this.state.isLoading }, this.state.isLoading ? (React.createElement(Loading, { size: "1rem" })) : ("CONFIRM")))));
    };
    toggleOn = (close) => {
        return (React.createElement(Card, { className: styles.toggleSyncPopup },
            React.createElement(Box, { className: styles.header },
                React.createElement("h2", { className: styles.title }, "Synchronise Settings"),
                React.createElement("div", { onClick: () => close(), className: styles.closeBtn },
                    React.createElement(Close, { onClick: () => close(), color: "#585C61", size: "0.75rem", className: styles.exitButton }))),
            React.createElement(Box, { className: styles.content },
                React.createElement(Typography, { sx: { marginBottom: "1rem" } },
                    "To ",
                    React.createElement("span", null, "turn on synchronisation"),
                    " for Roaming & IDD, please choose which configuration to keep:"),
                React.createElement(RadioGroup, { options: [
                        {
                            label: (React.createElement(React.Fragment, null,
                                React.createElement(Typography, null, "Copy Roaming settings to IDD"),
                                React.createElement(Typography, { sx: {
                                        color: "#888F97",
                                    } }, "The Roaming configuration will replace the current IDD setup"))),
                            value: Config.RoamingToIdd,
                        },
                        {
                            label: (React.createElement(React.Fragment, null,
                                React.createElement(Typography, null, "Copy IDD settings to Roaming"),
                                React.createElement(Typography, { sx: {
                                        color: "#888F97",
                                    } }, "The IDD configuration will replace the current Roaming setup"))),
                            value: Config.IDDToRoaming,
                        },
                    ], name: "syncConfig", value: this.state.syncConfig, valueChange: (_, value) => {
                        this.setState({ syncConfig: value });
                    }, spacingBetween: true })),
            React.createElement(Box, { className: styles.actions },
                React.createElement(Button, { click: () => close(), dark: true, className: styles.cancelBtn }, "CANCEL"),
                React.createElement(Button, { click: this.onSync }, this.state.isLoading ? (React.createElement(Loading, { size: "1rem" })) : ("CONFIRM")))));
    };
    render() {
        return (React.createElement(InfoPopup, { trigger: this.props.open, content: this.props.isSync ? this.toggleOff : this.toggleOn, onClose: () => this.props.close(false, this.props.isSync) }));
    }
}
